{
    "name": "cc_mobile_web_client",
    "version": "1.9.162",
    "private": true,
    "dependencies": {
        "@babel/preset-typescript": "^7.22.5",
        "@clerk/clerk-react": "^5.13.1",
        "@daveyplate/better-auth-tanstack": "^1.3.6",
        "@daveyplate/better-auth-ui": "^3.2.6",
        "@doodle3d/clipper-js": "^1.0.11",
        "@emotion/react": "^11.11.1",
        "@emotion/styled": "^11.9.3",
        "@fortawesome/fontawesome-svg-core": "^6.1.1",
        "@fortawesome/free-regular-svg-icons": "^6.1.1",
        "@fortawesome/free-solid-svg-icons": "^6.1.1",
        "@fortawesome/react-fontawesome": "^0.1.18",
        "@hcaptcha/react-hcaptcha": "^1.14.0",
        "@hookform/resolvers": "^3.9.0",
        "@internationalized/date": "^3.3.0",
        "@internationalized/number": "^3.1.1",
        "@marsidev/react-turnstile": "^1.1.0",
        "@mui/material": "^5.16.6",
        "@radix-ui/react-avatar": "^1.1.0",
        "@radix-ui/react-checkbox": "^1.1.0",
        "@radix-ui/react-dialog": "^1.1.0",
        "@radix-ui/react-dropdown-menu": "^2.1.0",
        "@radix-ui/react-label": "^2.1.0",
        "@radix-ui/react-select": "^2.2.0",
        "@radix-ui/react-separator": "^1.1.0",
        "@radix-ui/react-slot": "^1.1.0",
        "@radix-ui/react-tabs": "^1.1.0",
        "@react-hook/hover": "^4.0.0",
        "@react-hook/media-query": "^1.1.1",
        "@react-hook/mouse-position": "^4.1.3",
        "@react-hook/resize-observer": "^1.2.6",
        "@rooks/use-outside-click": "^4.11.2",
        "@ryki/datemath": "^1.3.4",
        "@sentry/react": "^7.73.0",
        "@sindresorhus/is": "4.6.0",
        "@skoging/react-app-rewire-source-map-loader": "^1.0.9",
        "@tanstack/react-query": "^4.18.0",
        "@tanstack/react-query-devtools": "^4.29.6",
        "@trpc/client": "^11.1.2",
        "@trpc/react": "^9.27.4",
        "@trpc/server": "^11.1.2",
        "add": "^2.0.6",
        "antd": "^4.7.3",
        "autoprefixer": "^10.4.21",
        "axios": "^0.19.0",
        "axios-request-handler": "^1.0.4",
        "better-auth": "^1.3.25",
        "bind-decorator": "^1.0.11",
        "change-case": "^4.1.2",
        "class-variance-authority": "^0.7.0",
        "classnames": "^2.2.5",
        "clsx": "^2.1.1",
        "copy-to-clipboard": "^3.3.1",
        "create-react-class": "^15.6.3",
        "cuid": "^2.1.8",
        "date-fns": "^3.6.0",
        "downloadjs": "^1.4.7",
        "element-resize-detector": "^1.2.3",
        "flux": "^2.1.1",
        "get-user-locale": "^1.5.1",
        "globalize": "^0.1.1",
        "hamjest": "^2.13.0",
        "history": "^1.17.0",
        "husl": "^6.0.1",
        "immutable": "^3.8.1",
        "immutable-tuple": "^0.4.10",
        "input-otp": "^1.4.2",
        "install": "^0.13.0",
        "iso-lang-codes": "^2.1.1",
        "jquery": "^3.4.1",
        "js-cookie": "^3.0.1",
        "js-file-download": "^0.4.8",
        "jwt-decode": "^4.0.0",
        "locale-currency": "^0.0.2",
        "localforage": "^1.10.0",
        "lodash.merge": "^4.3.5",
        "logrocket": "^1.2.2",
        "lucide-react": "^0.407.0",
        "mathjs": "^6.2.1",
        "mobx": "^6.0.1",
        "mobx-react": "^7.0.0",
        "mobx-react-lite": "^3.0.1",
        "mobx-utils": "^6.0.5",
        "mockdate": "^1.0.4",
        "moment": "^2.14.1",
        "mousetrap": "^1.6.1",
        "nearley": "^2.20.1",
        "npm": "^3.9.0",
        "numeral": "^2.0.6",
        "papaparse": "^4.3.6",
        "pluralize": "^8.0.0",
        "postcss": "^8.5.6",
        "posthog-js": "^1.239.0",
        "prop-types": "^15.7.2",
        "react": "^18.2.0",
        "react-addons-linked-state-mixin": "^15.0.2",
        "react-addons-pure-render-mixin": "^15.4.2",
        "react-addons-transition-group": "^15.3.2",
        "react-aria": "^3.19.0",
        "react-calendar": "^3.1.0",
        "react-data-grid": "^6.1.0",
        "react-dom": "^18.2.0",
        "react-draggable-list": "^4.1.0",
        "react-error-boundary": "^3.1.4",
        "react-hook-form": "^7.52.1",
        "react-input-autosize": "^1.1.0",
        "react-promise-suspense": "^0.3.3",
        "react-router": "^3.0.2",
        "react-scripts": "3.1.1",
        "react-select": "^5.4.0",
        "react-sortable-hoc": "^2.0.0",
        "react-tap-event-plugin": "^1.0.0",
        "react-textarea-autosize": "^4.0.1",
        "react-tooltip": "^5.19.0",
        "react-use-gesture": "^7.0.16",
        "react-widgets": "^3.4.5",
        "reselect": "^2.5.3",
        "rsvp": "^3.2.1",
        "sass": "^1.48.0",
        "sonner": "^1.7.0",
        "superjson": "^1.9.1",
        "tailwind-merge": "^2.6.0",
        "tailwindcss": "^3.0.0",
        "title-case": "^3.0.3",
        "trackjs": "^3.9.2",
        "typescript": "^5.1.6",
        "underscore": "^1.8.3",
        "velocity-animate": "^1.2.3",
        "vinyl-source-stream": "^1.1.0",
        "wait": "^0.4.2",
        "wouter": "^2.8.0-alpha.2",
        "xspans": "^1.0.1",
        "yarn": "^1.22.19",
        "zod": "^3.0.0"
    },
    "devDependencies": {
        "@babel/core": "^7.12.0",
        "@babel/plugin-proposal-class-properties": "^7.18.6",
        "@babel/plugin-proposal-decorators": "^7.4.4",
        "@babel/plugin-proposal-logical-assignment-operators": "^7.2.0",
        "@babel/plugin-proposal-nullish-coalescing-operator": "^7.4.4",
        "@babel/plugin-proposal-optional-chaining": "^7.2.0",
        "@babel/plugin-proposal-record-and-tuple": "^7.18.6",
        "@babel/preset-env": "^7.22.9",
        "@babel/preset-react": "^7.22.5",
        "@bloomberg/record-tuple-polyfill": "^0.0.4",
        "@parcel/packager-raw-url": "2.12.0",
        "@parcel/transformer-sass": "2.12.0",
        "@parcel/transformer-webmanifest": "2.12.0",
        "babel-loader": "8.0.6",
        "customize-cra": "^0.2.13",
        "enzyme": "^2.7.1",
        "json": "^9.0.4",
        "parcel": "^2.12.0",
        "qunitjs": "^2.0.0-rc1",
        "react-addons-test-utils": "^15.4.2",
        "react-app-rewired": "^2.1.3",
        "tailwind-scrollbar": "^4.0.2",
        "tailwindcss-animate": "^1.0.7"
    },
    "source": "./public/index.html",
    "scripts": {
        "start": "parcel --port 3001",
        "build": "parcel build --dist-dir build"
    },
    "parcel": {
        "extends": "@parcel/config-default",
        "transformers": {
            "*.txt": [
                "...",
                "@parcel/transformer-raw"
            ]
        },
        "contentHash": {
            "txt": false
        }
    },
    "eslintConfig": {
        "extends": "react-app"
    },
    "browserslist": {
        "production": [
            ">0.2%",
            "not dead",
            "not op_mini all"
        ],
        "development": [
            "last 1 chrome version",
            "last 1 firefox version",
            "last 1 safari version"
        ]
    },
    "engines": {
        "node": ">=20.19.0"
    },
    "alias": {
        "better-auth/react": "./node_modules/better-auth/dist/client/react/index.mjs",
        "better-auth/client": "./node_modules/better-auth/dist/client/index.mjs",
        "better-auth/client/plugins": "./node_modules/better-auth/dist/client/plugins/index.mjs"
    }
}
